export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14929.52d953f8.jpg";